// 关于我们  隐私协议
import { get } from '~/assets/js/api/methods'

import apiList from '~/api.config.js'
const { ad, homeClient } = apiList

export default (axios) => ({
  getAd: (params = {}) => get(axios, `${ad}/ad/window`, params), // 广告
  bottomad: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/index/advertisement/bottomad-v1`, params), // 底部广告
  topad: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/index/advertisement/topad-v1`, params) // 顶部广告
})
